import { all } from "redux-saga/effects";

import * as authHandler from "./auth";
import * as reportCampaignHandler from "./reportCampaign";

export default function* root() {
  yield all([
    authHandler.userEnterMobileForLoginWatcher(),
    authHandler.checkSmsCodeMobileForLoginWatcher(),
    authHandler.checkUserLoginWatcher(),

    // authHandler.registerUserWatcher(),

    reportCampaignHandler.getCampaignReportWithCampaignNameWatcher(),
  ]);
}
